import { Typography, Form, Row, Col, Button, Checkbox, message } from 'antd';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserRatingSetting, updateUserSetting } from './SettingFunction';
import {
  getCurrentOrganization,
  getCurrnetUserData,
} from 'store/slices/loginSlice';
import { listAllStages } from 'Pages/Stages/Services/StageActions';
import { setRatingList } from 'store/slices/StageSlice';

const RatingSetting = () => {
  const ratingOptions = [
    { label: 'Idea', value: 'IDEA' },
    { label: 'Opportunity', value: 'OPPORTUNITY' },
    { label: 'Project', value: 'PROJECT' },
  ];
  const [loading, setLoading] = useState(false);
  const [ratingData, setRatingData] = useState([]);
  const currnetOrg = useSelector(getCurrentOrganization);
  const loginUsrOrg = useSelector(getCurrnetUserData);
  const orgId = currnetOrg?.id || loginUsrOrg?.organizationID;
  // get user rating data
  const listUserRating = async () => {
    try {
      const res = await getUserRatingSetting({ id: orgId });
      let ratingFlage = res?.data?.getOrganization?.ratingFlags
        ? JSON.parse(res?.data?.getOrganization?.ratingFlags)
        : '';
      if (ratingFlage) {
        const result = Object.keys(ratingFlage).filter(
          (key) => ratingFlage[key]
        );
        setRatingData(result);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const dispatch = useDispatch();

  const [listStage, setListStage] = useState([]);
  const listAllStagesByOrg = async () => {
    try {
      let response = await listAllStages({ organizationID: orgId });
      let sortedLevel = response.items.sort((a, b) => a.level - b.level);
      setListStage(sortedLevel);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    listUserRating();
    listAllStagesByOrg();
    // eslint-disable-next-line
  }, []);

  // update user rating function
  const updateUserRatingData = async (e) => {
    setLoading(true);
    const ratingFlags = {};
    listStage.forEach((item) => {
      let id = item?.id;
      if (ratingData.includes(id)) {
        ratingFlags[id] = true;
      } else {
        ratingFlags[id] = false;
      }
    });
    const input = {
      id: orgId,
      ratingFlags: JSON.stringify(ratingFlags),
    };
    try {
      await updateUserSetting(input);
      dispatch(setRatingList(ratingData.length));
      message.success(`User Rating updated successfully`);
      listUserRating();
      setLoading(false);
    } catch (error) {
      message.error(error.message);
      setLoading(false);
    }
  };

  return (
    <div>
      <Typography.Title level={4} className="text-black fw-500">
        Item to be shown in rating
      </Typography.Title>

      <p className="mb-30">
        When performing ratings, all users will be subject to the following
        rating settings.
      </p>
      <Row>
        <Col span={22} md={22} sm={24} xs={24}>
          <Form.Item
            className="mb-0"
            label={<span>Select items to be shown in rating</span>}
            name="SMEWeight"
          />
          <Checkbox.Group
            onChange={(selectedIds) => setRatingData(selectedIds)}
            value={ratingData}
          >
            {listStage
              .filter((item) => item?.active)
              ?.map((rate) => {
                let checked = ratingData.includes(rate.id);
                return (
                  <Checkbox key={rate.id} value={rate.id} checked={checked}>
                    {rate.name}
                  </Checkbox>
                );
              })}
          </Checkbox.Group>
        </Col>
        <Col span={2} md={2} sm={24} xs={24}>
          <Row justify="end" align="bottom">
            <Button
              htmlType="submit"
              className="blue-filled-btn "
              size="middle"
              type="primary"
              loading={loading}
              onClick={(e) => updateUserRatingData(e)}
            >
              Save
            </Button>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default memo(RatingSetting);

